import useMediaStore from '../../../../shared/store/media.store.tsx'
import useTracksStore, {
  type TrackType,
} from '../../../../shared/store/tracks.store.tsx'
import { addDraggingClip } from './add-dragging-clip.ts'
import useAudioStore from '@/shared/store/audio.store.tsx'

export const addDraggingAudioClip = (
  id: string,
  name: string,
  duration: number,
  type: TrackType,
  getBufferFn: () => Promise<AudioBuffer>,
  uri?: string
): void => {
  const draggingClip = addDraggingClip(type, id, name, duration)
  const { setDraggedClip } = useTracksStore.getState()
  const { media, addMedia } = useMediaStore.getState()

  // Update clip with src if URI is provided
  if (uri) {
    setDraggedClip({
      ...draggingClip,
      src: uri,
    })
  }

  useAudioStore.getState().stopPlayback()

  if (!media[id]) {
    void getBufferFn().then((buffer) => {
      addMedia(id, buffer)
    })
  }

  const updateDraggedClip = (buffer: AudioBuffer): void => {
    // If the clip is not dragged anymore, we don't need to update the state
    const currentDraggedClip = useTracksStore.getState().draggedClip
    if (currentDraggedClip?.id !== draggingClip.id) return

    setDraggedClip({
      ...currentDraggedClip,
      duration: buffer.duration,
      // Preserve src if it was already set, or set it if URI is provided
      ...(uri
        ? { src: uri }
        : currentDraggedClip.src
          ? { src: currentDraggedClip.src }
          : {}),
    })
  }

  const existingBuffer = media[id]
  if (existingBuffer) {
    updateDraggedClip(existingBuffer)
    return
  }

  // Waiting until the buffer is loaded in the mediaStore
  const unsub = useMediaStore.subscribe(
    ({ media }) => media[id],
    (newBuffer) => {
      if (newBuffer) {
        updateDraggedClip(newBuffer)
        unsub()
      }
    },
    { fireImmediately: true }
  )
}
